module.exports = __webpack_public_path__ + "img/banner.14638402.jpg";